import { Clock, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal } from "./Reveal";

const Row = ({ icon: Icon, label, children, testid }) => (
    <div className="flex items-start gap-4" data-testid={testid}>
        <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-cream/10 text-coral">
            <Icon className="h-5 w-5" />
        </span>
        <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-cream/60">{label}</p>
            <div className="mt-1">{children}</div>
        </div>
    </div>
);

export const Contact = () => (
    <section id="contact" data-testid="contact-section" className="relative overflow-hidden bg-teal py-16 sm:py-24 lg:py-32 text-cream">
        <div className="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-coral/20 blur-3xl" />
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8">
            <div className="lg:col-span-7">
                <Reveal>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-coral" data-testid="contact-eyebrow">Contact</p>
                    <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-[1.08]" data-testid="contact-title">
                        Hai să vorbim despre<br />ce ai nevoie.
                    </h2>
                    <p className="mt-5 max-w-xl text-base sm:text-lg text-cream/80 leading-relaxed" data-testid="contact-text">
                        Prima discuție de potrivire este gratuită și durează cel mult 15 minute. Ne spui situația, noi îți spunem sincer dacă și cum te putem ajuta.
                    </p>
                </Reveal>

                <Reveal delay={0.1}>
                    <a
                        href={SITE.phoneHref}
                        data-testid="contact-phone-link"
                        className="mt-9 inline-flex items-center gap-4 font-serif text-3xl sm:text-5xl font-semibold tracking-tight text-cream transition-colors duration-300 hover:text-coral"
                    >
                        <span className="inline-flex h-12 w-12 sm:h-16 sm:w-16 items-center justify-center rounded-full bg-coral text-cream">
                            <Phone className="h-5 w-5 sm:h-7 sm:w-7" />
                        </span>
                        {SITE.phoneDisplay}
                    </a>
                </Reveal>

                <Reveal delay={0.16}>
                    <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
                        <Row icon={Phone} label="Telefon 1" testid="contact-phone1-row">
                            <a href={SITE.phoneHref} data-testid="contact-phone1-link" className="link-underline text-base sm:text-lg font-medium text-cream">
                                {SITE.phoneDisplay}
                            </a>
                        </Row>
                        <Row icon={Phone} label="Telefon 2" testid="contact-phone2-row">
                            <a href={SITE.phone2Href} data-testid="contact-phone2-link" className="link-underline text-base sm:text-lg font-medium text-cream">
                                {SITE.phone2Display}
                            </a>
                        </Row>
                        <Row icon={Mail} label="Email" testid="contact-email-row">
                            <a href={`mailto:${SITE.email}`} data-testid="contact-email-link" className="link-underline text-base sm:text-lg font-medium text-cream">
                                {SITE.email}
                            </a>
                        </Row>
                        <Row icon={MessageCircle} label="WhatsApp" testid="contact-whatsapp-row">
                            <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-link" className="link-underline text-base sm:text-lg font-medium text-cream">
                                Scrie-ne direct
                            </a>
                        </Row>
                        <Row icon={Clock} label="Program" testid="contact-schedule-row">
                            <p className="text-base sm:text-lg font-medium text-cream/90">{SITE.schedule}</p>
                        </Row>
                        <Row icon={MapPin} label="Zonă" testid="contact-area-row">
                            <p className="text-base sm:text-lg font-medium text-cream/90">{SITE.area}</p>
                        </Row>
                    </div>
                </Reveal>
            </div>

            <Reveal className="hidden lg:block lg:col-span-5" delay={0.15}>
                <div className="relative">
                    <div className="absolute -top-6 -right-6 h-28 w-28 rounded-full bg-coral/30" />
                    <div className="relative overflow-hidden rounded-t-[9rem] rounded-b-[2rem] ring-1 ring-cream/20" data-testid="contact-image">
                        <img
                            src="https://images.pexels.com/photos/8088906/pexels-photo-8088906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                            alt="Un senior liniștit acasă, lângă fereastră"
                            className="h-[30rem] w-full object-cover"
                        />
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
